import React, {useEffect, useState} from "react";
import Polyfill from "../../polyfill/polyfill";
import { Redirect, Route, Switch, useHistory, useLocation } from "react-router-dom";
import { Cookie, MetaData } from "../../components";
import NotFound from "../../components/404-2";
import config from "constants/config";
import authRoutes from "./routes";
import { useDispatch } from "react-redux";
import { getSelfUser } from "../../services/auth/actions";
import { useCookies } from 'react-cookie';
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import layoutHOC from "HOC/layoutHOC";
import { GoogleOAuthProvider } from '@react-oauth/google';
import { redirectToSubLink as redirectToSubRoute } from "../../components/subdomainLink";
import useAuthCookies from "../../hooks/useAuthCookies";


import "./app.scss";


function App() {

	let [isGoogleReady, setGoogleReady] = useState(false);
	let [isGoogleError, setGoogleError] = useState(false);
	let dispatch = useDispatch();
	let history = useHistory();
	let [ cookies ] = useCookies(['accessToken']);
	let { removeCookies } = useAuthCookies();

	useEffect(() => {

		const html = document.documentElement.classList;
		const body = document.body.classList;
		const elem = document.querySelector("#loader");



		body.remove("scroll-hidden");

		setTimeout(() => {
			if(elem) {
				elem.parentNode.removeChild(elem)
			}
			html.remove('scroll-hidden');
			body.remove('scroll-hidden');
		}, 1000);

		if(cookies.accessToken) {
			dispatch(getSelfUser())
				.then(() => {
					redirectToSubRoute('dashboard', '/', history)
				})
				.catch((res) => {
					if(res && (res.status === 401 || res.status === 400)) {
						removeCookies()
						redirectToSubRoute('auth', '/login', history)
					}
				});
		}

	}, []);

	const { pathname } = useLocation();
	const isSignUp = pathname.includes('appsumo') || pathname.includes('register');
	const currentYear = new Date().getFullYear();

	return (
		<GoogleOAuthProvider clientId={config.GOOGLE_CLIENT_ID} onScriptLoadSuccess={() => setGoogleReady(true)} onScriptLoadError={() => setGoogleError(true)}>
			<GoogleReCaptchaProvider reCaptchaKey={config.CAPTCHA_SITE_KEY_V3}>
				<div>
					<Cookie isAuth />
					<Polyfill />

					<Switch>

						{authRoutes.map(({ path, redirect, pathTo, metadata, component: Component }, key) =>
							redirect ?
								<Redirect from={path} to={pathTo} key={key} /> :
								<Route path={path} key={key}>
									<MetaData meta={metadata} >
										<div className={`auth-screen ${isSignUp ? 'sign-up' : ''}`}>
											<Component isGoogleReady={isGoogleReady} isGoogleError={isGoogleError} />
										</div>
										<div className="auth-screen-footer">Paylix UG © {currentYear} <div><a href="https://paylix.gg/legal/terms-of-service" target="_blank">Terms</a>·<a href="https://paylix.gg/legal/imprint" target="_blank">Imprint</a>·<a href="https://paylix.gg/legal/privacy-policy" target="_blank">Privacy</a></div></div>
									</MetaData>
								</Route>
						)}

						<Route path="*" component={NotFound} />

					</Switch>
				</div>
			</GoogleReCaptchaProvider>
		</GoogleOAuthProvider>
	)
}

export default layoutHOC(App)